import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import Email from 'Assets/svg/inline/email';
import Github from 'Assets/svg/inline/github';
import Linkedin from 'Assets/svg/inline/linkedin';
import CV from 'Assets/svg/inline/cv';

const SocialLink = ({ hrefLink, icon }) => (
  <a className="link" href={hrefLink} target="_blank" rel="noopener noreferrer">
    {icon()}
  </a>
);
SocialLink.propTypes = {
  hrefLink: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
};

const SocialLinks = ({ hoverName }) => (
  <div className={`socialLinks ${hoverName ? '' : 'grey'}`}>
    <SocialLink
      hrefLink="mailto:pedro.j.restrepo@gmail.com?Subject=Lets%20work%20together!"
      icon={Email}
    />
    <SocialLink
      hrefLink="https://github.com/PedroRestrepo"
      icon={Github}
    />
    <SocialLink
      hrefLink="https://ca.linkedin.com/in/pedrorestrepo"
      icon={Linkedin}
    />
    <SocialLink
      hrefLink="https://drive.google.com/file/d/0B2IR6T5eZ7eLbzROY2pxZGlXRUk/view?usp=sharing"
      icon={CV}
    />
  </div>
);
SocialLinks.propTypes = {
  hoverName: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  hoverName: state.App.hoverName,
});

export default connect(
  mapStateToProps,
  null,
)(SocialLinks);
